module.exports = __webpack_public_path__ + "static/media/RelaxMath.52d47a37.gif";